import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ align?: string }>()(
  (theme, { align }) => ({
    detailSectionWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
    detailsContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      gap: theme.spacing(0.5),
    },
    detailsContainerCompactRight: {
      paddingRight: 0,
      gap: 0,
    },
    detailsContent: {
      flex: 1,
      minWidth: 0,
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
    },
    buyerDetailRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      height: '44px',
      width: '100%',
    },
    detailRow: {
      padding: theme.spacing(2, 0),
      '&:last-of-type': {
        paddingBottom: theme.spacing(0),
      },
    },
    borderBottom: {
      borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
      '&:last-of-type': {
        borderBottom: 'none',
      },
    },
    title: {
      fontSize: '12px',
      color: theme.palette.labraText.description,
      lineHeight: theme.spacing(2),
      display: 'flex',
      alignItems: 'center',
    },
    value: {
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontWeight: 400,
      color: theme.palette.labraText.tertiary,
      lineHeight: '24px',
      fontStyle: 'normal',
      letterSpacing: '0.25px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '100%',
    },
    valueTooltipTrigger: {
      display: 'block',
      minWidth: 0,
      maxWidth: '100%',
    },
    divider: {
      flexShrink: 0,
    },
    infoIcon: {
      width: '16px',
      height: '16px',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      marginLeft: theme.spacing(1),
    },
    align: {
      alignItems: align,
    },
  })
)
